import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Clock } from 'lucide-react';
export default function Footer() {
  return <footer className="bg-primary text-white pt-12 pb-6" data-id="element-55">
      <div className="container mx-auto px-4" data-id="element-56">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-57">
          {/* About */}
          <div data-id="element-58">
            <div className="flex items-center mb-4" data-id="element-59">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hDXV1rDXM1m2ARqkQ9Hg8F/Medico_Favicon.png" alt="Medicolegal Psychiatry Logo" className="h-10 w-auto mr-3" data-id="element-60" />
              <h3 className="font-serif text-xl font-bold" data-id="element-61">
                Medicolegal Psychiatry
              </h3>
            </div>
            <p className="mb-4 text-sm leading-relaxed" data-id="element-62">
              Medico-Legal Psychiatry is led by Dr Imtiaz Syed, a GMC registered
              Psychiatrist and accredited Expert Witness. With over 20 years of
              clinical experience, we are committed to providing clear,
              impartial, and evidence-based psychiatric assessments across the
              UK.
            </p>
            <p className="text-sm leading-relaxed" data-id="element-63">
              Our services are guided by the principles of Clarity, Compassion,
              and Expertise, ensuring reliability and professionalism in every
              case.
            </p>
          </div>
          {/* Opening Hours */}
          <div data-id="element-64">
            <h3 className="font-serif text-xl font-bold mb-4 flex items-center" data-id="element-65">
              <Clock className="mr-2 h-5 w-5" data-id="element-66" />
              Opening Hours
            </h3>
            <ul className="space-y-2 text-sm" data-id="element-67">
              <li className="flex justify-between" data-id="element-68">
                <span data-id="element-69">Monday:</span>
                <span data-id="element-70">9:00am – 5:00pm</span>
              </li>
              <li className="flex justify-between" data-id="element-71">
                <span data-id="element-72">Tuesday:</span>
                <span data-id="element-73">9:00am – 5:00pm</span>
              </li>
              <li className="flex justify-between" data-id="element-74">
                <span data-id="element-75">Wednesday:</span>
                <span data-id="element-76">9:00am – 5:00pm</span>
              </li>
              <li className="flex justify-between" data-id="element-77">
                <span data-id="element-78">Thursday:</span>
                <span data-id="element-79">9:00am – 5:00pm</span>
              </li>
              <li className="flex justify-between" data-id="element-80">
                <span data-id="element-81">Friday:</span>
                <span data-id="element-82">9:00am – 5:00pm</span>
              </li>
              <li className="flex justify-between" data-id="element-83">
                <span data-id="element-84">Saturday:</span>
                <span data-id="element-85">9:00am – 1:00pm</span>
              </li>
              <li className="flex justify-between" data-id="element-86">
                <span data-id="element-87">Sunday:</span>
                <span data-id="element-88">Closed</span>
              </li>
            </ul>
          </div>
          {/* Quick Links */}
          <div data-id="element-89">
            <h3 className="font-serif text-xl font-bold mb-4" data-id="element-90">Quick Links</h3>
            <ul className="space-y-2 text-sm" data-id="element-91">
              <li data-id="element-92">
                <Link to="/about" className="hover:text-secondary transition-colors" data-id="element-93">
                  About Dr. Syed
                </Link>
              </li>
              <li data-id="element-94">
                <Link to="/services" className="hover:text-secondary transition-colors" data-id="element-95">
                  Our Services
                </Link>
              </li>
              <li data-id="element-96">
                <Link to="/faq" className="hover:text-secondary transition-colors" data-id="element-97">
                  FAQs
                </Link>
              </li>
              <li data-id="element-98">
                <Link to="/contact" className="hover:text-secondary transition-colors" data-id="element-99">
                  Contact Us
                </Link>
              </li>
              <li className="pt-2" data-id="element-100">
                <Link to="/policies/privacy" className="hover:text-secondary transition-colors" data-id="element-101">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-102">
                <Link to="/policies/terms" className="hover:text-secondary transition-colors" data-id="element-103">
                  Terms & Conditions
                </Link>
              </li>
              <li data-id="element-104">
                <Link to="/policies/cancellation" className="hover:text-secondary transition-colors" data-id="element-105">
                  Cancellation Policy
                </Link>
              </li>
            </ul>
          </div>
          {/* Contact */}
          <div className="lg:col-span-1" data-id="element-106">
            <h3 className="font-serif text-xl font-bold mb-4" data-id="element-107">Customer Care</h3>
            <div className="flex items-start mb-4" data-id="element-108">
              <Mail className="h-5 w-5 mr-2 mt-0.5" data-id="element-109" />
              <div data-id="element-110">
                <p className="font-medium" data-id="element-111">Email:</p>
                <a href="mailto:enquiries@medicolegal-psychiatry.co.uk" className="text-secondary hover:underline break-words" data-id="element-112">
                  enquiries@medicolegal-psychiatry.co.uk
                </a>
              </div>
            </div>
            <div className="mt-6" data-id="element-113">
              <h4 className="font-medium mb-2" data-id="element-114">Accreditations:</h4>
              <div className="flex flex-wrap gap-2" data-id="element-115">
                <a href="https://www.medco.org.uk/" target="_blank" rel="noopener noreferrer" className="transition-opacity hover:opacity-80" data-id="element-116">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8X52QHFHr2pezRgSGP8PRu/Medco.png" alt="MedCo" className="h-8" data-id="element-117" />
                </a>
                <a href="https://www.gmc-uk.org/" target="_blank" rel="noopener noreferrer" className="transition-opacity hover:opacity-80" data-id="element-118">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bdKLxaE25XhPcbz47Q5ek2/GMC.png" alt="GMC" className="h-8" data-id="element-119" />
                </a>
                <a href="https://ico.org.uk/" target="_blank" rel="noopener noreferrer" className="transition-opacity hover:opacity-80" data-id="element-120">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/oejz6MBWaYPHLboKrsxoJ8/ICO.png" alt="ICO" className="h-8" data-id="element-121" />
                </a>
                <a href="https://www.rcpsych.ac.uk/" target="_blank" rel="noopener noreferrer" className="transition-opacity hover:opacity-80" data-id="element-122">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/9akzzny18c2cokdDbeaSwa/RCPsych.png" alt="Royal College of Psychiatrists" className="h-8" data-id="element-123" />
                </a>
                <a href="https://www.bondsolon.com/" target="_blank" rel="noopener noreferrer" className="transition-opacity hover:opacity-80" data-id="element-124">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/r7LQZ1MUtT9MjPyaNm53VY/Bond_Solon.jpg" alt="Bond Solon" className="h-8" data-id="element-125" />
                </a>
                <a href="https://www.medschools.ac.uk/" target="_blank" rel="noopener noreferrer" className="transition-opacity hover:opacity-80" data-id="element-126">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6MiZXdLANurvspjz8K3bmS/medical_school_council.png" alt="Medical School Council" className="h-8" data-id="element-127" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="border-t border-white/20 mt-8 pt-6 text-center text-sm" data-id="element-128">
          <p data-id="element-129">
            © {new Date().getFullYear()} Medicolegal Psychiatry. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>;
}